import { render, staticRenderFns } from "./ScrollbarWidthDetector.vue?vue&type=template&id=3ae05290&scoped=true&"
import script from "./ScrollbarWidthDetector.vue?vue&type=script&lang=js&"
export * from "./ScrollbarWidthDetector.vue?vue&type=script&lang=js&"
import style0 from "./ScrollbarWidthDetector.vue?vue&type=style&index=0&id=3ae05290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae05290",
  null
  
)

export default component.exports